import styled from 'styled-components';
import { media } from '../../../../../theme/shared/breakpoints';
export const StyledRecentlySearched = styled.div `
  margin-top: 15px;
  padding-top: 15px;

  ${media.large} {
    padding-bottom: 0;
  }
`;
export const RecentlySearchedHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const RecentlySearchedHeaderText = styled.h5 `
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;

  ${media.large} {
    font-size: 18px;
    line-height: 26px;
  }
`;
//# sourceMappingURL=RecentlySearched.styled.js.map